export default __webpack_public_path__ + "static/media/about-sm-leaf1.777bb4c6.svg";